var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _PreventiveMaintenanceModel_id, _PreventiveMaintenanceModel_company_id, _PreventiveMaintenanceModel_asset_id, _PreventiveMaintenanceModel_name, _PreventiveMaintenanceModel_description, _PreventiveMaintenanceModel_freq_unit, _PreventiveMaintenanceModel_freq_value, _PreventiveMaintenanceModel_anchor_date, _PreventiveMaintenanceModel_grace_days, _PreventiveMaintenanceModel_checklist, _PreventiveMaintenanceModel_parts, _PreventiveMaintenanceModel_default_priority_cat, _PreventiveMaintenanceModel_default_assigned_to, _PreventiveMaintenanceModel_next_due_at, _PreventiveMaintenanceModel_active, _PreventiveMaintenanceModel_created_at, _PreventiveMaintenanceModel_updated_at, _PreventiveMaintenanceModel_created_by, _PreventiveMaintenanceModel_updated_by;
import { isNotEmptyString } from './utils/validationUtilities.js';
export var MaintenanceFrequency;
(function (MaintenanceFrequency) {
    MaintenanceFrequency["DAILY"] = "Daily";
    MaintenanceFrequency["WEEKLY"] = "Weekly";
    MaintenanceFrequency["MONTHLY"] = "Monthly";
    MaintenanceFrequency["QUARTERLY"] = "Quarterly";
    MaintenanceFrequency["ANNUALLY"] = "Annually";
})(MaintenanceFrequency || (MaintenanceFrequency = {}));
export class PreventiveMaintenanceModel {
    constructor(data = {}) {
        _PreventiveMaintenanceModel_id.set(this, void 0);
        _PreventiveMaintenanceModel_company_id.set(this, void 0);
        _PreventiveMaintenanceModel_asset_id.set(this, void 0);
        _PreventiveMaintenanceModel_name.set(this, void 0);
        _PreventiveMaintenanceModel_description.set(this, void 0);
        _PreventiveMaintenanceModel_freq_unit.set(this, void 0);
        _PreventiveMaintenanceModel_freq_value.set(this, void 0);
        _PreventiveMaintenanceModel_anchor_date.set(this, void 0);
        _PreventiveMaintenanceModel_grace_days.set(this, void 0);
        _PreventiveMaintenanceModel_checklist.set(this, void 0);
        _PreventiveMaintenanceModel_parts.set(this, void 0);
        _PreventiveMaintenanceModel_default_priority_cat.set(this, void 0);
        _PreventiveMaintenanceModel_default_assigned_to.set(this, void 0);
        _PreventiveMaintenanceModel_next_due_at.set(this, void 0);
        _PreventiveMaintenanceModel_active.set(this, void 0);
        _PreventiveMaintenanceModel_created_at.set(this, void 0);
        _PreventiveMaintenanceModel_updated_at.set(this, void 0);
        _PreventiveMaintenanceModel_created_by.set(this, void 0);
        _PreventiveMaintenanceModel_updated_by.set(this, void 0);
        // Ensure data is an object
        const safeData = data || {};
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_id, safeData.id || this.generateId(), "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_company_id, safeData.company_id || '', "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_asset_id, safeData.asset_id || '', "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_name, safeData.name || '', "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_description, safeData.description || '', "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_freq_unit, safeData.freq_unit || 'months', "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_freq_value, safeData.freq_value || 1, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_grace_days, safeData.grace_days || 0, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_default_priority_cat, safeData.default_priority_cat || 2, "f"); // Medium priority
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_default_assigned_to, safeData.default_assigned_to || '', "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_active, safeData.active !== undefined ? safeData.active : true, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_created_by, safeData.created_by || '', "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_by, safeData.updated_by || '', "f");
        // Handle date fields - store as Unix timestamps in milliseconds
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_created_at, safeData.created_at ?
            (typeof safeData.created_at === 'number' ? safeData.created_at : Date.now()) :
            Date.now(), "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, safeData.updated_at ?
            (typeof safeData.updated_at === 'number' ? safeData.updated_at : Date.now()) :
            Date.now(), "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_anchor_date, safeData.anchor_date ?
            (typeof safeData.anchor_date === 'number' ? safeData.anchor_date : Date.now()) :
            Date.now(), "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_next_due_at, safeData.next_due_at ?
            (typeof safeData.next_due_at === 'number' ? safeData.next_due_at : this.calculateNextDue()) :
            this.calculateNextDue(), "f");
        // Handle arrays
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_checklist, Array.isArray(safeData.checklist) ? safeData.checklist : [], "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_parts, Array.isArray(safeData.parts) ? safeData.parts : [], "f");
    }
    // Getters and Setters
    get id() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_id, "f");
    }
    set id(id) {
        if (!isNotEmptyString(id)) {
            throw new Error('ID is required and must be a non-empty string');
        }
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_id, id, "f");
    }
    get company_id() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_company_id, "f");
    }
    set company_id(company_id) {
        if (!isNotEmptyString(company_id)) {
            throw new Error('Company ID is required and must be a non-empty string');
        }
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_company_id, company_id, "f");
    }
    get asset_id() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_asset_id, "f");
    }
    set asset_id(asset_id) {
        if (!isNotEmptyString(asset_id)) {
            throw new Error('Asset ID is required and must be a non-empty string');
        }
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_asset_id, asset_id, "f");
    }
    get name() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_name, "f");
    }
    set name(name) {
        if (!isNotEmptyString(name)) {
            throw new Error('Name is required and must be a non-empty string');
        }
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_name, name, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, Date.now(), "f");
    }
    get description() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_description, "f");
    }
    set description(description) {
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_description, description, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, Date.now(), "f");
    }
    get freq_unit() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_freq_unit, "f");
    }
    set freq_unit(freq_unit) {
        const validUnits = ['days', 'weeks', 'months'];
        if (!validUnits.includes(freq_unit)) {
            throw new Error('Invalid frequency unit. Must be days, weeks, or months');
        }
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_freq_unit, freq_unit, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_next_due_at, this.calculateNextDue(), "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, Date.now(), "f");
    }
    get freq_value() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_freq_value, "f");
    }
    set freq_value(freq_value) {
        if (typeof freq_value !== 'number' || freq_value <= 0) {
            throw new Error('Frequency value must be a positive number');
        }
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_freq_value, freq_value, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_next_due_at, this.calculateNextDue(), "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, Date.now(), "f");
    }
    get anchor_date() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_anchor_date, "f");
    }
    set anchor_date(anchor_date) {
        if (typeof anchor_date !== 'number') {
            throw new Error('Anchor date must be a valid number (Unix epoch timestamp)');
        }
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_anchor_date, anchor_date, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_next_due_at, this.calculateNextDue(), "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, Date.now(), "f");
    }
    get grace_days() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_grace_days, "f");
    }
    set grace_days(grace_days) {
        if (typeof grace_days !== 'number' || grace_days < 0) {
            throw new Error('Grace days must be a non-negative number');
        }
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_grace_days, grace_days, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, Date.now(), "f");
    }
    get next_due_at() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_next_due_at, "f");
    }
    set next_due_at(next_due_at) {
        if (typeof next_due_at !== 'number') {
            throw new Error('Next due at must be a valid number (Unix epoch timestamp)');
        }
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_next_due_at, next_due_at, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, Date.now(), "f");
    }
    get active() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_active, "f");
    }
    set active(active) {
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_active, active, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, Date.now(), "f");
    }
    get created_at() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_created_at, "f");
    }
    set created_at(created_at) {
        if (typeof created_at !== 'number') {
            throw new Error('Created at must be a valid number (Unix epoch timestamp)');
        }
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_created_at, created_at, "f");
    }
    get updated_at() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_updated_at, "f");
    }
    set updated_at(updated_at) {
        if (typeof updated_at !== 'number') {
            throw new Error('Updated at must be a valid number (Unix epoch timestamp)');
        }
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, updated_at, "f");
    }
    get default_priority_cat() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_default_priority_cat, "f");
    }
    set default_priority_cat(default_priority_cat) {
        if (typeof default_priority_cat !== 'number' || default_priority_cat < 1 || default_priority_cat > 4) {
            throw new Error('Default priority category must be between 1 and 4');
        }
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_default_priority_cat, default_priority_cat, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, Date.now(), "f");
    }
    get default_assigned_to() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_default_assigned_to, "f");
    }
    set default_assigned_to(default_assigned_to) {
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_default_assigned_to, default_assigned_to, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, Date.now(), "f");
    }
    get checklist() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_checklist, "f");
    }
    set checklist(checklist) {
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_checklist, Array.isArray(checklist) ? checklist : [], "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, Date.now(), "f");
    }
    get parts() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_parts, "f");
    }
    set parts(parts) {
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_parts, Array.isArray(parts) ? parts : [], "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, Date.now(), "f");
    }
    get created_by() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_created_by, "f");
    }
    set created_by(created_by) {
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_created_by, created_by, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, Date.now(), "f");
    }
    get updated_by() {
        return __classPrivateFieldGet(this, _PreventiveMaintenanceModel_updated_by, "f");
    }
    set updated_by(updated_by) {
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_by, updated_by, "f");
        __classPrivateFieldSet(this, _PreventiveMaintenanceModel_updated_at, Date.now(), "f");
    }
    // Static methods
    static get frequencies() {
        return Object.values(MaintenanceFrequency);
    }
    // Instance methods
    isOverdue() {
        const now = Date.now();
        const gracePeriod = this.grace_days * 24 * 60 * 60 * 1000; // Convert days to milliseconds
        return this.next_due_at < (now - gracePeriod);
    }
    isDueToday() {
        const today = new Date();
        const todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate()).getTime();
        const todayEnd = todayStart + (24 * 60 * 60 * 1000);
        return this.next_due_at >= todayStart && this.next_due_at < todayEnd;
    }
    isDueThisWeek() {
        const now = Date.now();
        const weekFromNow = now + (7 * 24 * 60 * 60 * 1000);
        return this.next_due_at <= weekFromNow;
    }
    getDaysUntilDue() {
        const now = Date.now();
        const diffTime = this.next_due_at - now;
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }
    getDaysOverdue() {
        if (!this.isOverdue())
            return 0;
        const now = Date.now();
        const gracePeriod = this.grace_days * 24 * 60 * 60 * 1000;
        const diffTime = now - (this.next_due_at + gracePeriod);
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }
    // Calculate the next due date based on frequency
    advanceNextDue() {
        this.next_due_at = this.calculateNextDue();
        this.updated_at = Date.now();
    }
    calculateNextDue() {
        const baseDate = this.anchor_date;
        const now = Date.now();
        // Calculate the interval in milliseconds
        let intervalMs;
        switch (this.freq_unit) {
            case 'days':
                intervalMs = this.freq_value * 24 * 60 * 60 * 1000;
                break;
            case 'weeks':
                intervalMs = this.freq_value * 7 * 24 * 60 * 60 * 1000;
                break;
            case 'months':
                // For months, we need to be more precise with calendar months
                const baseDateObj = new Date(baseDate);
                const nextDateObj = new Date(baseDateObj);
                nextDateObj.setMonth(nextDateObj.getMonth() + this.freq_value);
                return nextDateObj.getTime();
            default:
                intervalMs = 30 * 24 * 60 * 60 * 1000; // Default to 30 days
        }
        // For days and weeks, calculate the next due date
        if (this.freq_unit === 'days' || this.freq_unit === 'weeks') {
            let nextDue = baseDate;
            while (nextDue <= now) {
                nextDue += intervalMs;
            }
            return nextDue;
        }
        return now + intervalMs; // Fallback
    }
    toJSON() {
        return {
            id: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_id, "f"),
            company_id: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_company_id, "f"),
            asset_id: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_asset_id, "f"),
            name: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_name, "f"),
            description: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_description, "f"),
            freq_unit: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_freq_unit, "f"),
            freq_value: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_freq_value, "f"),
            anchor_date: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_anchor_date, "f"),
            grace_days: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_grace_days, "f"),
            checklist: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_checklist, "f"),
            parts: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_parts, "f"),
            default_priority_cat: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_default_priority_cat, "f"),
            default_assigned_to: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_default_assigned_to, "f"),
            next_due_at: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_next_due_at, "f"),
            active: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_active, "f"),
            created_at: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_created_at, "f"),
            updated_at: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_updated_at, "f"),
            created_by: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_created_by, "f"),
            updated_by: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_updated_by, "f"),
            is_overdue: this.isOverdue(),
            days_until_due: this.getDaysUntilDue(),
            days_overdue: this.getDaysOverdue()
        };
    }
    toFirestore() {
        return {
            id: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_id, "f"),
            company_id: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_company_id, "f"),
            asset_id: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_asset_id, "f"),
            name: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_name, "f"),
            description: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_description, "f"),
            freq_unit: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_freq_unit, "f"),
            freq_value: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_freq_value, "f"),
            anchor_date: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_anchor_date, "f"),
            grace_days: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_grace_days, "f"),
            checklist: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_checklist, "f"),
            parts: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_parts, "f"),
            default_priority_cat: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_default_priority_cat, "f"),
            default_assigned_to: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_default_assigned_to, "f"),
            next_due_at: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_next_due_at, "f"),
            active: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_active, "f"),
            created_at: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_created_at, "f"),
            updated_at: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_updated_at, "f"),
            created_by: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_created_by, "f"),
            updated_by: __classPrivateFieldGet(this, _PreventiveMaintenanceModel_updated_by, "f")
        };
    }
    generateId() {
        return `pm_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    }
}
_PreventiveMaintenanceModel_id = new WeakMap(), _PreventiveMaintenanceModel_company_id = new WeakMap(), _PreventiveMaintenanceModel_asset_id = new WeakMap(), _PreventiveMaintenanceModel_name = new WeakMap(), _PreventiveMaintenanceModel_description = new WeakMap(), _PreventiveMaintenanceModel_freq_unit = new WeakMap(), _PreventiveMaintenanceModel_freq_value = new WeakMap(), _PreventiveMaintenanceModel_anchor_date = new WeakMap(), _PreventiveMaintenanceModel_grace_days = new WeakMap(), _PreventiveMaintenanceModel_checklist = new WeakMap(), _PreventiveMaintenanceModel_parts = new WeakMap(), _PreventiveMaintenanceModel_default_priority_cat = new WeakMap(), _PreventiveMaintenanceModel_default_assigned_to = new WeakMap(), _PreventiveMaintenanceModel_next_due_at = new WeakMap(), _PreventiveMaintenanceModel_active = new WeakMap(), _PreventiveMaintenanceModel_created_at = new WeakMap(), _PreventiveMaintenanceModel_updated_at = new WeakMap(), _PreventiveMaintenanceModel_created_by = new WeakMap(), _PreventiveMaintenanceModel_updated_by = new WeakMap();
//# sourceMappingURL=PreventiveMaintenanceModel.js.map